import { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { FaUserPlus, FaUserCheck } from "react-icons/fa6";
import makePutRequest from "../utils/makePutRequest";
import PopUpModulBtn from "../PopUpModulBtn";

const FollowSection = ({ followers }) => {
  const followersData =
    typeof followers === "number"
      ? { count: followers, user_has_followed: false }
      : followers || {};

  const [counter, setCounter] = useState(followersData.count || 0);
  const [hasFollowed, setHasFollowed] = useState(followersData.user_has_followed || false);
  const token = useSelector((state) => state.token);

  const canPersistFollow = followersData.band_id != null;

  const handleFollowClick = async () => {
    const newHasFollowed = !hasFollowed;
    const newCounter = hasFollowed ? counter - 1 : counter + 1;
    const action = newHasFollowed ? "follow" : "unfollow";

    setCounter(newCounter);
    setHasFollowed(newHasFollowed);

    if (canPersistFollow) {
      const { error } = await upDateFollowsOnServer(action);
      if (error) {
        console.error(
          `[FollowSection] Misslyckades att spara ${action} för band id=${followersData.band_id}: ${error}`
        );
        setCounter(counter);
        setHasFollowed(hasFollowed);
      }
    }
  };

  const upDateFollowsOnServer = (action) => {
    const data = {
      band_id: followersData.band_id,
      action: action,
    };
    return makePutRequest("follow_action", data);
  };

  if (token) {
    return (
      <div className="mt-4 mb-2 pt-4 flex items-center gap-2">
        <button
          onClick={handleFollowClick}
          className={`btn btn-sm gap-2 ${
            hasFollowed ? "btn-neutral text-white" : "btn-primary"
          }`}
        >
          {hasFollowed ? <FaUserCheck size={16} /> : <FaUserPlus size={16} />}
          {hasFollowed ? "Följer" : "Följ"}
        </button>
        {counter > 0 && (
          <span className="text-xs font-bold bg-base-300 text-base-content/70 px-2 py-1 rounded-full">
            {counter}
          </span>
        )}
      </div>
    );
  } else {
    return (
      <div className="mt-4 mb-2 pt-4 flex items-center gap-2">
        <PopUpModulBtn
          btnText={
            <span className="flex items-center gap-2">
              <FaUserPlus size={16} />
              Följ
            </span>
          }
          btnStyle="btn-sm btn-primary"
          modalId="follow"
          title="Logga in för att följa"
          text="För att kunna följa musikprojekt behöver du vara inloggad. Logga in eller skapa ett konto för att fortsätta."
        >
          <div className="flex justify-center gap-4">
            <a href="/login">
              <button className="btn btn-primary border border-base-content/20">
                Logga in
              </button>
            </a>
            <a href="/register">
              <button className="btn btn-secondary border border-base-content/20">
                Skapa konto
              </button>
            </a>
          </div>
        </PopUpModulBtn>
        {counter > 0 && (
          <span className="text-xs font-bold bg-base-300 text-base-content/70 px-2 py-1 rounded-full">
            {counter}
          </span>
        )}
      </div>
    );
  }
};

FollowSection.propTypes = {
  followers: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      count: PropTypes.number,
      user_has_followed: PropTypes.bool,
      band_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ]),
};

export default FollowSection;
